function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#029D29"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.416 8.459a.5.5 0 1 0-.707.707L6.27 10.73a.5.5 0 0 0 .695.012l4.688-4.375a.5.5 0 1 0-.683-.732L6.637 9.68l-1.22-1.221z",
  fill: "#FFF"
});

var SvgCreditCardValidatedMarkIcon = function SvgCreditCardValidatedMarkIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreditCardValidatedMarkIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/credit_card_validated_mark_icon.63b6b5a4.svg";
export { ForwardRef as ReactComponent };